import { createContext, useContext, useState, useEffect, useCallback } from "react";

import { BACKEND_URL } from "@/config/runtime";

const SiteContentContext = createContext(null);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchContent = useCallback(async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/site-content`);
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      }
    } catch (error) {
      console.error("Failed to fetch site content:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  // Helper function to get content with fallback
  const getContent = useCallback((key, fallback = "") => {
    return content[key] || fallback;
  }, [content]);

  // Refresh content (useful after admin edits)
  const refreshContent = useCallback(() => {
    fetchContent();
  }, [fetchContent]);

  return (
    <SiteContentContext.Provider
      value={{
        content,
        siteContent: content,
        loading,
        getContent,
        refreshContent,
      }}
    >
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => {
  const context = useContext(SiteContentContext);
  if (!context) {
    throw new Error("useSiteContent must be used within a SiteContentProvider");
  }
  return context;
};
